import { useEffect } from 'react';

import type { TSmeCarouselDots } from '../components/dots/models';

export const useUpdateDelay = ({ delay, styles }: Pick<TSmeCarouselDots, 'styles' | 'delay'>) => {
    useEffect(() => {
        const dots = document.querySelector(`.${styles.dots}`) as HTMLElement;
        if (dots) {
            // например: 'delay_ZxI0X linear 4000ms'
            const delayAnimationCssValue = getComputedStyle(dots).getPropertyValue(
                '--sme-carousel-duration-animation'
            );
            if (delayAnimationCssValue) {
                dots.style.setProperty(
                    '--sme-carousel-duration-animation',
                    delayAnimationCssValue.replace(/\d+ms/, delay * 1000 + 'ms')
                );
            }
        }
    }, [delay, styles.dots]);
};
